import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import LeftMenu from "../../../components/layout/leftMenu";
import Header from "../../../components/layout/header";
import {
  useDispatch,
  useLocation,
  useSelector,
} from "../../../components/hooks/hooks";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { backendApi } from "../../../api/apiService";
import ReactStars from "react-stars";
import { FaTrash } from "react-icons/fa";
import CandidateInfo from "../../leads/candidateInfo";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ReactSelect from "react-select";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import Loading from "../../../images/loading.gif";
export default function Evaluation() {
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };
  const re = /^(?:\d{1,2}|20)?$/;
  const re2 = /^[0-9]*$/;
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingQns, setisSubmittingQns] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [addnewQtn, setAddnewQtn] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const { userDetails, userData } = useSelector((state) => state.login);
  const [menuClick, setMenuClick] = useState(false);
  const [candidateId, setCandidateId] = useState(location?.state?.candidateId);
  const [jobSkills, setJobSkills] = useState([]);
  const [jobSkillsInit, setJobSkillsInit] = useState([]);
  const [difficultyList, setDifficultyList] = useState([
    { label: "Beginner", value: "Beginner" },
    { label: "Intermediate", value: "Intermediate" },
    { label: "Advanced", value: "Advanced" },
  ]);
  const [difficulty, setDifficulty] = useState("");
  const [selectedJobSkills, setSelectedJobSkills] = useState([]);
  const [selectedSkillsString, setSelectedSkillsString] = useState('');
  const [candidate, setCandidate] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState("");
  const [selectedTechSkills, setSelectedTechSkills] = useState("");
  const [rating, setRating] = useState(0);
  const [ratingTech, setRatingTech] = useState(0);
  const [newRemarks, setNewRemarks] = useState("");
  const [newRemarksTech, setNewRemarksTech] = useState("");
  const [interviewData, setInterviewData] = useState("");
  const [ResultFromAI, setResultFromAI] = useState([]);
  const [dataResult, setdataResult] = useState(false);
  const [otherInterviewerData, setOtherInterviewerData] = useState([]);
  const [savedInterviewSkills, setSavedInterviewSkills] = useState([]);
  const [currentUserInterviewSkills, setCurrentUserInterviewSkills] = useState([]);
  const [noOfQuestions, setNoOfQuestions] = useState(5);
  const [duration, setDuration] = useState(5);
  const [AIquestions, setAIQuestions] = useState([])
  const [newQuestion, setNewQuestion] = useState('');
  const [options, setOptions] = useState([
    { text: '', isAnswer: false },
    { text: '', isAnswer: false },
    { text: '', isAnswer: false },
    { text: '', isAnswer: false }
  ]);

  const statecandidateId = location?.state?.candidateId;
  console.log(statecandidateId, "statecandidateId");


  const handleQuestionChange = (e) => {
    setNewQuestion(e.target.value);
  };
  const handleOptionChange = (index, e) => {
    const newOptions = [...options];
    newOptions[index].text = e.target.value;
    setOptions(newOptions);
  };
  const handleAnswerChange = (index) => {
    const newOptions = options.map((opt, i) => ({
      ...opt,
      isAnswer: i === index
    }));
    setOptions(newOptions);
  };

  const SubNewQuestion = () => {
    const areAllFieldsFilled = options.every(opt => opt.text.trim() !== '');
    const isAnyOptionChecked = options.some(opt => opt.isAnswer === true);
    if (!areAllFieldsFilled) {
      toast.warning("Please fill all the option fields.", { containerId: "Z" });
      return;
    }

    if (!isAnyOptionChecked) {
      toast.warning("Please select at least one correct answer.", { containerId: "Z" });
      return;
    }
    const formattedOptions = options.map(opt => ({
      optionsvalue: opt.text,
      isAnswer: opt.isAnswer ? '1' : '0'
    }));

    const newQuestionData = {
      question: newQuestion,
      options: formattedOptions
    };

    setAIQuestions(prevQuestions => {
      if (!Array.isArray(prevQuestions)) {
        console.error("prevQuestions is not an array:", prevQuestions);
        return [];
      }
      const updatedQuestions = [...prevQuestions, newQuestionData];
      console.log("Updated AIquestions:", updatedQuestions);
      return updatedQuestions;
    });
    setNewQuestion('');
    setOptions([
      { text: '', isAnswer: false },
      { text: '', isAnswer: false },
      { text: '', isAnswer: false },
      { text: '', isAnswer: false }
    ]);

  };
  const handleBack = () => {
    console.log('Location state:', location.state);
    if (location.state?.from === 'oldshedules') {
      navigate('/schedule/schedules');
    } else if (location.state?.from === 'candidateProfile') {
      navigate(`/candidateprofile/${candidateId}`);

    }
    else {

    }
  };
  //? Initial useEffect to fetch data
  useEffect(() => {
    candidateInit();
  }, []);

  //? Function to toggle Left Menu
  const closeMenu = () => {
    setMenuClick(false);
  };
  const addNewQuestion = () => {
    setAddnewQtn(true);
  };
  //? Function to toggle Header Menu
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };

  //? Function to get Initial Candidate Data
  const candidateInit = () => {
    var req = {
      functionName: "candidateProfile",
      site_id: userDetails[0].site_id,
      candidate_id: candidateId,
    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        console.log(response.data , "candidateProfile data");
        
        //! Filtering skills based on created user
        const currentUserSkills = [];
        const otherUserSkills = [];
        const interviewData = response.interviewDetails.filter(
          (obj) => Number(obj.Interviewer_id) === userData[0].id
        )[0];
        for (const [index, data] of response.savedInterviewSkills.entries()) {
          if (data.interview_id === interviewData.id) {
            currentUserSkills.push(data);
          } else {
            otherUserSkills.push(data);
          }
        }

        let interviewersList = response.interviewDetails.filter(
          (o) => Number(o.Interviewer_id) !== userData[0].id
        );
        for (const intData of interviewersList) {
          intData["skills"] = otherUserSkills.filter(
            (obj) => obj.interview_id === intData.id
          );
        }
        setOtherInterviewerData(interviewersList);
        setSavedInterviewSkills(otherUserSkills);
        setCurrentUserInterviewSkills(currentUserSkills);
        setJobSkillsInit(
          response.candidate_skills.map((skill, index) => ({
            value: skill.id,
            label: skill.skill_name,
          }))
        );
        const transformedOptions = response.candidate_skills.map(
          (skill, index) => ({
            value: skill.id,
            label: skill.skill_name,
          })
        );
        setJobSkills(transformedOptions);
        setCandidate(response.dataSet);

        setInterviewData(interviewData);
      } else {
        console.error("Error while fetching candidate data");
        return false;
      }
    });
  };
  //? Function to handle skill select both technical/behavioural
  const handleSkillSelect = (selectedOption, technical) => {
    if (Boolean(technical)) {
      setSelectedTechSkills(selectedOption);
    } else {
      setSelectedSkills(selectedOption);
    }
  };

  //? Function to enter new skills into skills dropdown both technical/behavioural
  const insertNewSkill = (event) => {
    if (event.key == "Enter" && event.target.value.trim() !== "") {
      const newSkillLabel = event.target.value.trim();
      const skillExists = jobSkills.some(
        (skill) => skill.label.toLowerCase() === newSkillLabel.toLowerCase()
      );
      let newSkillValue = jobSkills.length;
      if (!skillExists) {
        const newSkill = {
          label: newSkillLabel,
          value: newSkillValue,
        };
        setJobSkills([...jobSkills, newSkill]);
      }
      event.target.value = "";
    }
  };

  //? Function to save selected skills both technical/behavioural
  const handleAddSelectedSkills = (technical) => {
    if (!interviewData) {
      toast.error("Interview doesn't exist", { containerId: "Z" });
      return;
    }
  
    const skillData = technical === 0 ? selectedSkills : selectedTechSkills;
    const ratingData = technical === 0 ? rating : ratingTech;
    const remarksData = technical === 0 ? newRemarks : newRemarksTech;
  
    const skillExists = currentUserInterviewSkills.some(
      (skill) =>
        skill.skill_name === skillData.label && skill.is_technical === technical
    );
  
    if (skillExists) {
      toast.error("Skill already exists", { containerId: "Z" });
      return;
    }
  
    const newSkill = {
      skill_name: skillData.label,
      rating: ratingData,
      is_technical: technical,
      remarks: remarksData,
    };
  
    const updatedSkills = [...currentUserInterviewSkills, newSkill];
    setCurrentUserInterviewSkills(updatedSkills);
  
    const req = {
      functionName: "saveInterviewSkills",
      interview_id: interviewData.id,
      candidate_id: candidateId,
      skill_name: [newSkill.skill_name],  
      ratings: [String(newSkill.rating || 0)],  
      remarks: [String(newSkill.remarks || "NA")], 
      isTechnical: technical,
      created_by: userData.id,
    };
  
    backendApi(req).then((response) => {
      if (response.success === "1") {
        toast.success("Review submitted successfully", { containerId: "Z" });
        setSelectedSkills("");
        setSelectedTechSkills("");
        setRatingTech(0);
        setRating(0);
        setNewRemarks("");
        setNewRemarksTech("");
      } else {
        console.error("Error", response);
        return false;
      }
    });
  };
  
  
  

  //? Function to cancel add skills both tech/behave
  const cancelNewRow = (technical) => {
    // setNewRow(false);
    if (Boolean(technical)) {
      setSelectedTechSkills("");
      setRatingTech(0);
      setNewRemarksTech("");
    } else {
      setSelectedSkills("");
      setRating(0);
      setNewRemarks("");
    }
  };

  //? Function to edit rating both tech/behave
  const editRating = (rating, skill_id) => {
    const api = {
      functionName: "editInterviewDetails",
      rating,
      skill_id,
    };
    backendApi(api).then((response) => {
      candidateInit();
    });
  };

  //? Function To delete skill tech/behave
  const deleteSkill = (skill_id) => {
    const api = {
      functionName: "deleteInterviewSkills",
      skill_id,
    };
    backendApi(api).then((response) => {
      candidateInit();
    });
  };

  //? Function To handle Input in select
  const handleSelectInput = (event) => {
    if (event.key == "Enter" && event.target.value.trim() !== "") {
      const newSkillLabel = event.target.value.trim();
      const skillExists = jobSkillsInit.some(
        (skill) => skill.label.toLowerCase() === newSkillLabel.toLowerCase()
      );
      let newSkillValue = jobSkillsInit.length;
      if (!skillExists) {
        const newSkill = {
          label: newSkillLabel,
          value: newSkillValue,
        };
        setJobSkillsInit([...jobSkillsInit, newSkill]);
      }
      event.target.value = "";
    }
  };
  const selectSkills = (selectedOptions) => {
    setSelectedJobSkills(selectedOptions);
    const labels = selectedOptions.map(option => option.label);
    const labelsString = labels.join(', ');
    console.log(selectedOptions);
    console.log(labelsString);
    setSelectedSkillsString(labelsString)
  };
  const handleSelectRangeChange = (event) => {
    const selectedValue = event.target.value;
    setDifficulty(selectedValue);
    console.log('Selected Skill:', selectedValue);
  };

  //?Function using ChatGPT API to get questions
  const openAiFunction = () => {
    if (!selectedSkillsString) {
      toast.warn("Select Skills", { containerId: "Z" });
      return;
    }
    if (!difficulty) {
      toast.warn("Select Level", { containerId: "Z" });
      return;
    }
    const completePrompt = `Give me a list of ${noOfQuestions} multiple choice questions for an interview in JSON Format with ${difficulty} difficulty relating to the skills ${selectedSkillsString}. Give me 1 correct answer option and 3 other wrong options. The output must be in the format, 
"questionArray": [
  {
  "question": "question1",
  "options": [
    {
    "optionsvalue": "Wrong Answer"
    "isAnswer": "0"
    },
    {
    "optionsvalue": "Correct Answer"
    "isAnswer": "1"
    },
    {
    "optionsvalue": "Wrong Answer"
    "isAnswer": "0"
    },
    {
    "optionsvalue": "Wrong Answer"
    "isAnswer": "0"
    }
  ]
  },
  {
    "question": "question2",
    "options": [
      {
      "optionsvalue": "Wrong Answer"
      "isAnswer": "0"
      },
      {
      "optionsvalue": "Correct Answer"
      "isAnswer": "1"
      },
      {
      "optionsvalue": "Wrong Answer"
      "isAnswer": "0"
      },
      {
      "optionsvalue": "Wrong Answer"
      "isAnswer": "0"
      }
    ]
  }, etc (other questions with options) ...
]
where the correct answer will have isAnswer = 1 and others will have isAnswer = 0. Please provide only JSON strictly with the above format without any explanations.`;
    setIsSubmitting(true);
    const req = {
      functionName: "chatGpt_openai",
      prompt: completePrompt,
    };
    console.log(completePrompt);
    backendApi(req).then((response) => {
      setIsSubmitting(false);

      console.log("🚀 ~ backendApi ~ response:", response);
      try {
        const content = response.data.choices[0].message.content;
        console.log("Raw content:", content);
        const fixedContent = content.endsWith('}') ? content : content + '}';

        const parsedContent = JSON.parse(fixedContent);
        console.log(parsedContent, "response data from chat ai");
        if (parsedContent && Array.isArray(parsedContent.questionArray)) {
          setAIQuestions(parsedContent.questionArray);
        } else {
          console.error("Parsed content does not contain a valid `questionArray`:", parsedContent);
        }

        setResultFromAI(parsedContent.questionArray || []);
        setdataResult(true);
      } catch (error) {
        setIsSubmitting(false);
        console.error("Failed to parse JSON:", error);
      }
    })
      .catch((error) => {
        console.error("Failed to fetch data from backend:", error);
      });

  };

  //SUBMIT QUESTIONARE DATA
  const SumbitQnreData = (e) => {
    e.preventDefault();
    setisSubmittingQns(true)
    var req = {
      functionName: "saveQuestion",
      site_id: window.localStorage.getItem("siteId"),
      questionArray: AIquestions,
      candidate_id: candidateId,
      created_by: localStorage.getItem("userId"),
      exam_time: duration,
      total_question: AIquestions.length,
      schedule_date_time: ""
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      setisSubmittingQns(false)
      if (response.success === "1") {
        toast.success("Questions saved successfully", { containerId: "Z" });
        setAIQuestions([])
        setResultFromAI([])
        setdataResult(false);
        setAddnewQtn(false);
        setSelectedJobSkills([]);
        setDifficulty("")
      } else {
        setisSubmittingQns(false)
        toast.warn("Error", { containerId: "Z" });
      }
    });
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header
            Header="Candidate Evaluation"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          />
          <div className="main-container evalution-div pb-2">
            <ToastContainer
              enableMultiContainer
              containerId={"Z"}
              position="bottom-right"
              autoClose={1500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />

            <div className="card main-card-box">
              <div className="card-body">
                <CandidateInfo
                  key={candidate}
                  fieldDisableOrNot={true}
                  candidateInit={candidateInit}
                  candidate={candidate[0]}
                />
              </div>
            </div>

            {/* ================= EVALUATION ================= */}


                 <div className="card main-card-box main-card">
              <div className="card-body">
                <Tabs
                  selectedIndex={tabIndex}
                  onSelect={(index) => setTabIndex(index)}
                >
                </Tabs>
                <div className="row justify-content-center py-2 m-auto align-items-center">
                  <div className="col-lg-2 col-12 mb-2 mb-lg-0">
                    <label className="col-form-label">No of questions:</label>
                    <input
                      className="form-control"
                      value={noOfQuestions}
                      onChange={(e) => re.test(e.target.value) && setNoOfQuestions(e.target.value)}
                    />
                  </div>
                  <div className="col-lg-2 col-12 mb-2 mb-lg-0">
                    <label className="col-form-label">Time:</label>
                    <div className="d-md-flex gap-2 align-items-center">
                      <input
                        type="number"
                        min={5}
                        step={5}
                        max={60}
                        onChange={(e) => setDuration(e.currentTarget.value)}
                        value={duration}
                        className="form-control"
                      />
                      <span>Secs. / Question</span>
                    </div>
                  </div>
                  <div className="col-lg-3 col-12 mb-2 mb-lg-0">
                    <label className="col-form-label">Skills:</label>
                    <ReactSelect
                      isMulti
                      value={selectedJobSkills}
                      options={jobSkillsInit}
                      onChange={selectSkills}
                      onInputChange={(e) => handleSelectInput(e)}
                    />
                  </div>
                  <div className="col-lg-3 col-12 mb-2 mb-lg-0">
                    <label className="col-form-label">Difficulty:</label>
                    <select
                      id="jobSkills"
                      className="form-control"
                      value={difficulty}
                      onChange={handleSelectRangeChange}
                    >
                      <option value="">Select Level</option>
                      <option value="Beginner">Beginner</option>
                      <option value="Intermediate">Intermediate</option>
                      <option value="Advanced">Advanced</option>
                    </select>
                  </div>
                  <div className="col-lg-2 col-12 d-flex align-items-center justify-content-center">
                    <button
                      className="btn-btn btn btn-btn2"
                      onClick={() => openAiFunction()}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <img src={Loading} alt="loaderImg" width={20} height={20} ></img>
                      ) : (
                        "Generate Questions"
                      )}

                    </button>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-end my-2">

                  {dataResult ? <button
                    className="btn-outline-primary btn btn-sm w-auto"
                    onClick={() => addNewQuestion()}
                  >
                    Add New Question
                  </button> : ""}


                </div>

                {addnewQtn && (
                  <div className="m-3">
                    <div className="row mt-3">
                      <div className="question-outlines d-flex">
                        <div className="col-lg-6 col-6">
                          <textarea
                            rows="3"
                            className="form-control"
                            placeholder="Enter your question here"
                            value={newQuestion}
                            onChange={handleQuestionChange}
                          />
                        </div>
                        <div className="col-lg-6 d-flex align-items-center justify-content-center col-6">
                          <div className="row">
                            {options.map((opt, index) => (
                              <div key={index} className="col-lg-6">
                                <div className="d-flex align-items-center gap-3">
                                  <input
                                    type="text"
                                    placeholder="Enter your Answer"
                                    value={opt.text}
                                    className="form-control"
                                    onChange={(e) => handleOptionChange(index, e)}
                                  />
                                  <input
                                    type="checkbox"
                                    checked={opt.isAnswer}
                                    onChange={() => handleAnswerChange(index)}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <button className="btn-outline-primary btn btn-sm offset-10" onClick={SubNewQuestion}>
                      Add Question
                    </button>
                  </div>
                )}
                {AIquestions.map((questionObj, questionIndex) => (
                  <div className="m-3">
                    <div key={questionIndex} className="row mt-3">
                      <div className="question-outlines d-flex">
                        <div className="col-lg-6 col-6">
                          <textarea
                            rows="3"
                            className="form-control"
                            placeholder="Enter your Questions here"
                            value={questionObj.question}
                            readOnly
                          />
                        </div>
                        <div className="col-lg-6 d-flex align-items-center justify-content-center col-6">
                          <div className="row">
                            {questionObj.options.map((option, optionIndex) => (
                              <div key={optionIndex} className="col-lg-6 mb-2">
                                <div className="d-flex align-items-center gap-1">
                                  <div className="flex-grow-1">{option.optionsvalue}</div>
                                  <div>
                                    <input
                                      type="checkbox"
                                      checked={option.isAnswer === '1'}
                                      readOnly
                                      className="form-check-input"
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                ))}
                {dataResult ? <button
                  className="btn-outline-primary btn btn-sm offset-10"
                  onClick={SumbitQnreData}
                  disabled={isSubmittingQns}
                >
                  {isSubmittingQns ? (
                    <img src={Loading} alt="loaderImg" width={20} height={20} ></img>
                  ) : (
                    " Save Questions"
                  )}
                </button> : ""}
              </div>
            </div>

            {/* ================= */}

            {/* <div className="dash-sub-head mb-2 ps-3">Candidate Evaluation</div> */}
            <div className="card main-card-box">
              <div className="card-body pb-0">
                <h4 className="dash-sub-innerhead">Behaviour Assessment</h4>

                <div className="table-responsive">
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <td aria-label="Skills" className="pb-4">
                          <Select
                            name="colors"
                            placeholder="Skills"
                            options={jobSkills}
                            // value={skillId}
                            value={selectedSkills}
                           
                            styles={{zIndex:"10"}}
                            onChange={(e) => handleSkillSelect(e, 0)}
                            onKeyDown={(event) => insertNewSkill(event)}
                          // className="basic-multi-select"
                          // classNamePrefix="select"
                          />
                        </td>
                        <td aria-label="Sl.No" className="pb-4">
                          <ReactStars
                            key={rating}
                            count={5}
                            onChange={setRating}
                            isHalf={true}
                            value={Number(rating)}
                            size={24}
                            activeColor="#ffd700"
                          />
                        </td>
                        <td className="pb-4">
                          <input
                            type="text"
                            value={newRemarks}
                            class="form-control"
                            onChange={(e) => setNewRemarks(e.target.value)}
                            placeholder="Enter Remarks..."
                          />
                        </td>
                        <td className="pb-4">
                          <div class="">
                            <button
                              class="btn-btn btn btn-btn1 me-2"
                              onClick={() => handleAddSelectedSkills(0)}
                            >
                              Save
                            </button>
                            <button
                              class="btn-btn btn btn-btn2"
                              onClick={() => {
                                cancelNewRow(0);
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </td>
                      </tr>
                    </thead>
                    {currentUserInterviewSkills.length > 0 &&
                      currentUserInterviewSkills.some(
                        (o) => o.is_technical !== 1
                      ) ? (
                      <>
                        <thead>
                          <tr>
                            <th style={{ minWidth: "200px" }}>Skills</th>
                            <th style={{ minWidth: "200px" }}>Rating</th>
                            <th style={{ minWidth: "200px" }}>Remarks</th>
                            <th style={{ minWidth: "150px" }}>Actions</th>
                          </tr>
                        </thead>

                        <tbody>
                          <>
                            {currentUserInterviewSkills.map((data) => {
                              if (data.is_technical !== 1)
                                return (
                                  <tr>
                                    <td aria-label="Skills">
                                      {data.skill_name}
                                    </td>
                                    <td aria-label="Sl.No">
                                      <ReactStars
                                        count={5}
                                        value={data.rating}
                                        isHalf={true}
                                        onChange={(e) => editRating(e, data.id)}
                                        size={24}
                                        activeColor="#ffd700"
                                      />
                                    </td>
                                    <td>
                                      {data.remarks &&
                                        data.remarks !== "undefined"
                                        ? data.remarks
                                        : "NA"}
                                    </td>
                                    <td>
                                      <span>
                                        <FaTrash
                                          color="red"
                                          onClick={() => deleteSkill(data.id)}
                                        />
                                      </span>
                                    </td>
                                  </tr>
                                );
                            })}
                          </>
                        </tbody>
                      </>
                    ) : (
                      <p className="no-skills-found">
                        No Skills found. Please add new!!
                      </p>
                    )}
                  </table>
                </div>
              </div>
            </div>
            <div className="card main-card-box">
              <div className="card-body pb-0">
                <h4 className="dash-sub-innerhead">Technical Assessment</h4>

                <div className="table-responsive">
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <td aria-label="Skills" className="pb-4">
                          <Select
                            name="colors"
                            placeholder="Skills"
                            options={jobSkills}
                            value={selectedTechSkills}
                            onChange={(e) => handleSkillSelect(e, 1)}
                            onKeyDown={(event) => insertNewSkill(event)}
                            styles={{zIndex:"10"}}
                          />
                        </td>
                        <td aria-label="Sl.No" className="pb-4">
                          <ReactStars
                            key={ratingTech}
                            count={5}
                            onChange={(e) => setRatingTech(e)}
                            value={ratingTech}
                            size={24}
                            activeColor="#ffd700"
                          />
                        </td>
                        <td className="pb-4">
                          <input
                            type="text"
                            value={newRemarksTech}
                            class="form-control"
                            onChange={(e) => setNewRemarksTech(e.target.value)}
                            placeholder="Enter Remarks..."
                          />
                        </td>
                        <td className="pb-4">
                          <div class="">
                            <button
                              class="btn-btn btn btn-btn1 me-2"
                              onClick={() => handleAddSelectedSkills(1)}
                            >
                              Save
                            </button>
                            <button
                              class="btn-btn btn btn-btn2"
                              onClick={() => {
                                cancelNewRow(1);
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </td>
                      </tr>
                    </thead>

                    {currentUserInterviewSkills.length > 0 &&
                      currentUserInterviewSkills.some(
                        (o) => o.is_technical !== 0
                      ) ? (
                      <>
                        <thead>
                          <tr>
                            <th style={{ minWidth: "200px" }}>Skills</th>
                            <th style={{ minWidth: "200px" }}>Rating</th>
                            <th style={{ minWidth: "200px" }}>Remarks</th>
                            <th style={{ minWidth: "150px" }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <>
                            {currentUserInterviewSkills.map((data) => {
                              if (data.is_technical !== 0)
                                return (
                                  <tr>
                                    <td aria-label="Skills">
                                      {data.skill_name}
                                    </td>
                                    <td aria-label="Sl.No">
                                      <ReactStars
                                        count={5}
                                        value={data.rating}
                                        onChange={(e) => editRating(e, data.id)}
                                        isHalf={true}
                                        size={24}
                                        activeColor="#ffd700"
                                      />
                                    </td>
                                    <td>
                                      {data.remarks &&
                                        data.remarks !== "undefined"
                                        ? data.remarks
                                        : "NA"}
                                    </td>
                                    <td>
                                      <span>
                                        <FaTrash
                                          color="red"
                                          onClick={() => deleteSkill(data.id)}
                                        />
                                      </span>
                                    </td>
                                  </tr>
                                );
                            })}
                          </>

                          {/* <tr>
                                              <td aria-label="Skills">
                                                Communication
                                              </td>
                                              <td aria-label="Sl.No">
                                                <ReactStars
                                                  count={5}
                                                  //  onChange={ratingChanged}
                                                  size={24}
                                                  activeColor="#ffd700"
                                                />
                                              </td>
                                              <td>none</td>
                                            </tr> */}
                          {/* {NewRow ? (

                                                ) : (
                                                  ""
                                                )} */}
                        </tbody>
                      </>
                    ) : (
                      <tfoot>
                        <tr>
                          <td colSpan={4}>
                            <p className="no-skills-found">
                              No Skills found. Please add new!!
                            </p>
                          </td>
                        </tr>
                      </tfoot>

                    )}
                  </table>
                </div>
              </div>
            </div>
            {otherInterviewerData.length > 0 ? (
              <>
                <div className="dash-sub-head mb-2 ps-3">
                  Evaluation by other Interviewers
                </div>
                <div className="card main-card-box">
                  <div className="card-body">
                    <>
                      {otherInterviewerData.map((o) => {
                        return (
                          <>
                            <h4 className="dash-inervier-head">
                              {o.Interviewer_name}
                            </h4>
                            <>
                              {/* BEHAVIOUR ASSESSMENT */}

                              <h4 className="dash-sub-innerhead">
                                Behaviour Assessment
                              </h4>

                              <div className="table-responsive">
                                <table className="table mb-0">
                                  {o.skills.length > 0 &&
                                    o.skills.some((o) => o.is_technical !== 1) ? (
                                    <>
                                      <thead>
                                        <tr>
                                          <th style={{ minWidth: "200px" }}>
                                            Skills
                                          </th>
                                          <th style={{ minWidth: "200px" }}>
                                            Remarks
                                          </th>
                                          <th style={{ minWidth: "100px" }}>
                                            Remarks
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        <>
                                          {o.skills.map((data) => {
                                            if (data.is_technical !== 1)
                                              return (
                                                <tr>
                                                  <td aria-label="Skills">
                                                    {data.skill_name}
                                                  </td>
                                                  <td aria-label="Sl.No">
                                                    <ReactStars
                                                      count={5}
                                                      value={data.rating}
                                                      isHalf={true}
                                                      size={24}
                                                      activeColor="#ffd700"
                                                    />
                                                  </td>
                                                  <td>
                                                    {data.remarks &&
                                                      data.remarks !== "undefined"
                                                      ? data.remarks
                                                      : "NA"}
                                                  </td>
                                                </tr>
                                              );
                                          })}
                                        </>
                                      </tbody>
                                    </>
                                  ) : (
                                    <p className="no-skills-found">
                                      No Skills found. Please add new!!
                                    </p>
                                  )}
                                </table>
                              </div>

                              {/* TECHNICAL ASSESSMENT */}
                              <h4 className="dash-sub-innerhead">
                                Technical Assessment
                              </h4>
                              <div className="table-responsive">
                                <table className="table mb-0">
                                  {o.skills.length > 0 &&
                                    o.skills.some((o) => o.is_technical !== 0) ? (
                                    <>
                                      <thead>
                                        <tr>
                                          <th style={{ minWidth: "200px" }}>
                                            Skills
                                          </th>
                                          <th style={{ minWidth: "200px" }}>
                                            Rating
                                          </th>
                                          <th style={{ minWidth: "100px" }}>
                                            Remarks
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <>
                                          {o.skills.map((data) => {
                                            if (data.is_technical !== 0)
                                              return (
                                                <tr>
                                                  <td aria-label="Skills">
                                                    {data.skill_name}
                                                  </td>
                                                  <td aria-label="Sl.No">
                                                    <ReactStars
                                                      count={5}
                                                      value={data.rating}
                                                      isHalf={true}
                                                      size={24}
                                                      activeColor="#ffd700"
                                                    />
                                                  </td>
                                                  <td>
                                                    {data.remarks &&
                                                      data.remarks !== "undefined"
                                                      ? data.remarks
                                                      : "NA"}
                                                  </td>
                                                </tr>
                                              );
                                          })}
                                        </>
                                      </tbody>
                                    </>
                                  ) : (
                                    <p className="no-skills-found">
                                      No Skills found. Please add new!!
                                    </p>
                                  )}
                                </table>
                              </div>
                            </>
                          </>
                        );
                      })}
                    </>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            <button
              type="button"
              className="floating-back-button"
              onClick={handleBack}
            >
              <BsArrowLeftCircleFill size={24}/>
            </button>
          </div>
        </div>
      </div >
    </>
  );
}
